import SignTypesListPageContainer from './containers/SignTypesListPageContainer'

export default SignTypesListPageContainer
